var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1074_14451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7202 17.1846L14.9317 12.2377C14.5883 11.8828 14.1592 11.7407 13.9732 11.9222C13.7867 12.1024 13.3572 11.9606 13.0138 11.6057L12.9454 11.5347C15.0885 8.71598 14.8805 4.68022 12.3069 2.10662C9.49808 -0.702207 4.94391 -0.702207 2.13543 2.10662C-0.673399 4.91545 -0.673399 9.46898 2.13543 12.2778C4.75286 14.8956 8.884 15.0709 11.7085 12.81L11.7385 12.8414C12.0813 13.1963 12.2089 13.6299 12.0218 13.8103C11.8355 13.9909 11.9622 14.4248 12.306 14.779L17.0918 19.7278C17.4352 20.0818 18.001 20.0923 18.3563 19.7487L19.6994 18.4491C20.0533 18.1062 20.0629 17.5408 19.7202 17.1846ZM10.7264 10.6971C8.79345 12.6304 5.64801 12.6304 3.71539 10.6978C1.78247 8.76488 1.78276 5.61909 3.71539 3.68652C5.64801 1.7536 8.79345 1.75389 10.7257 3.68681C12.6589 5.61944 12.6589 8.76458 10.7264 10.6971Z",
    fill: "#7F94A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1074_14451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGrayIcon);
export default __webpack_public_path__ + "static/media/search-gray-icon.a97adf4d77a580c73fcfffbae3506610.svg";
export { ForwardRef as ReactComponent };